import { useState } from "react";
import { toast } from "react-toastify";
import { exportRegisters } from "@services/registers/export";
import { exportToCSV, formatCSVData } from "@utils/export";
import { formatDateTime, actualDateTime } from "@utils/formatters";
import { getGenderLabel } from "@utils/translator/individuals";
import {
  getEnvironmentLabel,
  getTypeLabel as getRegisterTypeLabel,
  type RegisterEnvironment,
  type RegisterType,
} from "@typings/entities/registers/enums";
import type { Gender } from "@typings/entities/individuals";
import { REGISTERS_EXPORT_HEADS } from "@typings/entities/registers/export";
import type { RegistersFilters } from "@services/registers/list/type";

export function useExportRegisters() {
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async (filters?: RegistersFilters) => {
    setIsLoading(true);
    try {
      const response = await exportRegisters(filters);

      if (!response.items?.length) {
        toast.warning("Nenhum dado de registros disponível para exportar");
        return;
      }

      const translatedData = response.items.map((item) => ({
        ...item,
        anonymousIndividualGender: item.anonymousIndividualGender
          ? getGenderLabel(item.anonymousIndividualGender as Gender)
          : "",
        environment: item.environment
          ? getEnvironmentLabel(item.environment as RegisterEnvironment)
          : "",
        type: getRegisterTypeLabel(item.type as RegisterType),
        registerDate: formatDateTime(item.registerDate),
        sampleCollected: item.sampleCollected ? "Sim" : "Não",
        createdAt: formatDateTime(item.createdAt),
        updatedAt: formatDateTime(item.updatedAt),
      }));

      const formattedData = formatCSVData(
        translatedData,
        REGISTERS_EXPORT_HEADS,
      );
      exportToCSV(formattedData, `relatorio_registros_${actualDateTime()}`);
      toast.success("Relatório de registros exportado com sucesso!");
    } catch {
      toast.error("Erro ao exportar relatório de registros");
    } finally {
      setIsLoading(false);
    }
  };

  return { handleExport, isLoading };
}
